export const socialsData = {
    github: 'https://github.com/Mdshahbazalam6',
    linkedIn: 'https://www.linkedin.com/in/md-shahbaz-alam-6a8679197/',
}